import { render } from "./DownloadIcon.vue?vue&type=template&id=3db23a06"
const script = {}
script.render = render

export default script